import { render, staticRenderFns } from "./return-to-sender-modal.vue?vue&type=template&id=2c1fe3ab&"
import script from "./return-to-sender-modal.vue?vue&type=script&lang=ts&"
export * from "./return-to-sender-modal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports